import * as yup from 'yup';

export const initialValues = {
  selectedGiftTable: '',
};

export const schema = yup.object().shape({
  selectedGiftTable: yup.string(),
});
